export const AuthInitialState = {
  token: {
    accessToken: '',
    refreshToken: '',
    isLoading: true,
  },
  userClaimObject: {
    name: '',
    email: '',
    unixId: '',
    roleId: '',
    id: '',
  },
  restrictedProductSquad: [],
  userRestrictedEcosystemt: [],
  userRestriction: [],
  wrapperObj: [],
  favReportObj: [],
  componentAccessList: [],
};
